import Convention from "models/convention-api/v1/Convention"
import ConventionRegistration from "models/convention-api/v1/ConventionRegistration"
import { createContext } from "react"

interface ILaunchpadContext {
  convention: Convention
  conventionRegistration?: ConventionRegistration | null
  userCount: number
}

// @ts-ignore
const LaunchpadContext = createContext<ILaunchpadContext>(null)

export default LaunchpadContext
